var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"mb-2",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":_vm.addRow}},[_c('i',{staticClass:"fa fa-fw fa-plus"}),_vm._v("\n        "+_vm._s(_vm.trans('add_row'))+"\n    ")]),_vm._v(" "),(!_vm.hideColBtn)?_c('b-button',{staticClass:"mb-2 ml-2",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":_vm.addCol}},[_c('i',{staticClass:"fa fa-fw fa-plus"}),_vm._v("\n        "+_vm._s(_vm.trans('add_column'))+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('hot-table',{ref:"hotTable",attrs:{"language":_vm.lang,"settings":Object.assign({}, {data: _vm.json,
            licenseKey: 'non-commercial-and-evaluation',
            colHeaders: this.col ? this.col : true,
            rowHeaders: true,
            customBorders: true,
            dropdownMenu: true,
            multiColumnSorting: true,
            filters: true,
            manualRowMove: true,
            contextMenu: true,
            autoWrapRow: true,
            autoWrapCol: true,
            afterChange: function (data) {
                // if loadsource data is null
                if (this$1.hotRef && data) {
                    this$1.$emit('input', this$1.hotRef.getSourceData())
                }
            }},
            _vm.params)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }